import React, { useState, useEffect } from 'react'
import { Message, Tooltip } from '@arco-design/web-react'
import {
  IconCopy,
  IconUse,
  IconSuccessTip,
  IconWarnTip,
} from '@arco-iconbox/react-aidb-v2'
import { IconQuestionCircle } from '@arco-design/web-react/icon'
import { events } from '@/helpers/event-emitter'
import { ACTIONS } from '@/share/constants'
import { includeKeyWord } from './utils/utilsFunction'
import Copy from '../Copy'
import Empty from './Empty'
import { RewriteHighlightPlugin } from '../../pages/writingContent/lib/custom/plugins/rewriteHighlightMark'

import styles from './style/search-text-mod.module.less'

interface Props {
  setVisible: (boolean) => void
  content: string
  keyWord: string
  title?: string
}

const SearchTextMod = (props: Props) => {
  const { setVisible, content, keyWord, title } = props

  const [activeText, setActiveText] = useState<string>('')

  // 内容回屏
  const contentReturnHandle = () => {
    events.emit(ACTIONS.DIRECTIVES_ADOPT_EDITOR, {
      content: activeText ? activeText : content,
    })
    setVisible(false)
  }

  // 选中内容
  const getSelectedText = () => {
    let text = window.getSelection().toString()
    setActiveText(text)
    console.log(text)
  }

  // 显示详细信息函数
  const ShowDetailedInformation = ({ title }) => {
    return (
      <span style={{ marginLeft: '5px' }}>
        <Tooltip content={title}>
          <IconQuestionCircle />
        </Tooltip>
      </span>
    )
  }

  return (
    <div className={styles['content']}>
      <div className={styles.title}>{title ? title : '正文内容'}</div>
      {content ? (
        <div
          className={styles.text}
          onMouseUp={getSelectedText}
          dangerouslySetInnerHTML={{
            __html: includeKeyWord(content, [keyWord]),
          }}></div>
      ) : (
        <div className={`${styles.text} ${styles.textEmpty}`}>
          <Empty state={content ? false : true} title="暂无数据！" />
        </div>
      )}
      {/* 按钮 */}
      <div className={styles.btn}>
        {/* 复制 */}
        <Copy
          className={styles.btnItem}
          text={content}
          onCopy={() => {
            if (!content) return
            setVisible(false)
            Message.success({
              icon: <IconSuccessTip useCurrentColor={false} />,
              content: '复制成功！',
            })
          }}
          content={
            <>
              <div className={styles.icon}>
                <IconCopy useCurrentColor={true} />
              </div>
              <div className={styles.txt}>复制</div>
            </>
          }
        />
        <div
          className={`${styles.btnItem} ${
            activeText ? styles.btnItemActive : ''
          }`}
          onClick={contentReturnHandle}>
          <div className={styles.icon}>
            <IconUse useCurrentColor={true} />
          </div>
          <div className={styles.txt}>
            内容回屏
            <ShowDetailedInformation
              title={
                '若没有在浮层中选择，则全部回屏。若编辑器没有选择，则回屏到光标位置。若没有最近一次光标，则回屏到尾部。'
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchTextMod
